import Timer from './Timer';
import Game from '../../../Game';
import { TimerType } from '../TimerTypes';
import DateHelper from '../../../Utility/DateHelper';
import { TimerActions } from '../../../State/Timer/TimerActions';
import { IGameState } from '../../../State/Game/IGameState';

export default class FarmMiniGameTimer extends Timer {
    public complete(): void {
        TimerActions.updateTimer({
            timer: TimerType.FARM_MINI_GAME,
            time: null,
        });
        // Game.scene.getActiveScene().emit('TransitionCrops');
        this.onComplete();
    }
    public onComplete(): void {}
    public isCompleted(state: IGameState = Game.store.getState()): boolean {
        const startDate: Date = this.getDate(state);

        return startDate === null
            ? true
            : DateHelper.now.getTime() - startDate.getTime() >
                  this.getDuration().duration;
    }
    public getDuration(): { duration: number; format: string } {
        const duration: number = DateHelper.HalfDay;

        const format: string = duration <= DateHelper.Hour ? 'mm:ss' : 'hh:mm:ss';

        return { duration, format };
    }

    public getDate(state: IGameState = Game.store.getState()): Date {
        return state.playerState.timers.get(TimerType.FARM_MINI_GAME);
    }
}
